import React, { Component } from 'react';
import { TranslatedBlock } from 'src/components/language';
import DownloadIcon from '../images/download-icon-blue.svg';
import './three-column-cards.scss';
import CardOneImage from '../images/Doctor_Dis_Guide.png';
import CardTwoImage from '../images/V_Info_Brochure.png';
import CardThreeImage from '../images/Vabysmo_Treatment_G.jpg';
import CardFourImage from '../images/V_Amsler_Grid.png';

import { AppStateContext } from 'src/contexts/app-state-provider.context'

class threeColumnCards extends Component {
  contextType = AppStateContext;
  state = {
    isAudioVisible: false
  };

  trackDownloads(eventName, fileName = '', event = null) {
    console.log('🎯 Download Tracking Triggered:', { eventName, fileName });
    
    // Mark this event as tracked to prevent double-counting by global listener
    if (event) {
      event.__ga4Tracked = true;
    }
    
    const fileName_extracted = fileName ? fileName.split('/').pop() : '';
    const fileExtension = fileName ? fileName.split('.').pop() : '';
    
    // GA4 tracking - use proper event name
    if (window.gtag) {
      // Fire specific named event (NEW)
      window.gtag('event', eventName, {
        file_name: fileName,
        file_extension: fileExtension,
        file_path: fileName,
        timestamp: new Date().toISOString()
      });
      console.log('📊 GA4 Event Sent:', {
        event: eventName,
        file_name: fileName,
        file_extension: fileExtension
      });
      
      // Fire legacy 'patient_resources_pdf' event for backward compatibility with existing reports
      window.gtag('event', 'patient_resources_pdf', {
        file_name: fileName,
        file_extension: fileExtension,
        file_path: fileName,
        timestamp: new Date().toISOString()
      });
      console.log('📊 GA4 Legacy Event Sent (backward compatibility): patient_resources_pdf');
    } else {
      console.warn('⚠️ GA4 gtag not available');
    }
    
    // Adform conversion tracking for downloads
    if (window._adftrack) {
      const adformData = {
        HttpHost: 'asia.adform.net',
        pm: 3214201,
        divider: encodeURIComponent('|'),
        pagename: encodeURIComponent('download'),
        custom: {
          'file_name': fileName_extracted,
          'file_type': fileExtension,
          'download_action': eventName
        }
      };
      window._adftrack.push(adformData);
      console.log('🎯 Adform Event Sent:', adformData);
    } else {
      console.warn('⚠️ Adform _adftrack not available');
    }
  }
  render() {

    return (
      <section className="three-column-section threecolumn-variation">
        <div className="three-column-section">
          <div className="pd-24">
            <div className="row">
              <div className=" col-md-3 col-xs-12 ">
                <div className='image-on-card'>
                  <TranslatedBlock language="english">
                    <a href="/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf" target="_blank" title="Eye Care Professional" onClick={(e) => this.trackDownloads("eyecare_discussion_guide_download", "/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf", e)}>
                      <img srcSet={CardOneImage} alt="Eye Care Professional" className={'img-responsive'} />
                    </a>
                  </TranslatedBlock>
                </div>
                <div className='textonCard text-center'>
                  <h4><a href="/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf" title="Eye Care Professional Discussion Guide" target="_blank" className='' onClick={(e) => this.trackDownloads("eyecare_discussion_guide_download", "/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf", e)}>Eye Care Professional Discussion Guide </a></h4>
                  <p>Helpful questions to discuss with your Eye Care Professional to better understand your condition and treatment options</p>
                  <a href="/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf" title="View Eye Care Discussion Guide" target="_blank" className='yellow-buttons' onClick={(e) => this.trackDownloads("eyecare_discussion_guide_download", "/pdf/NZ_Eye-Care-Doctor-Discussion-Guide_M-NZ-00000719_v3_NOV2025.pdf", e)}>
                    View Eye Care Discussion Guide</a>

                </div>
              </div>

              <div className=" col-md-3 col-xs-12 ">
                <div className='image-on-card'>
                  <TranslatedBlock language="english">
                    <a href="/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf" target="_blank" title="treatment for wet AMD or DMO" onClick={(e) => this.trackDownloads("education_brochure_download", "/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf", e)}>
                      <img srcSet={CardTwoImage} alt="treatment for wet AMD or DMO" className={'img-responsive'} />
                    </a>
                  </TranslatedBlock>
                </div>
                <div className='textonCard text-center'>
                  <h4><a href="/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf" target="_blank" className='' title="Considering Treatment with VABYSMO" onClick={(e) => this.trackDownloads("education_brochure_download", "/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf", e)}>Considering Treatment with VABYSMO?</a></h4>
                  <p>Written and visual information for patients considering VABYSMO as a treatment for wet AMD, DMO or RVO</p>
                  <a href="/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf" target="_blank" className='yellow-buttons' title="View Information Brochure	" onClick={(e) => this.trackDownloads("education_brochure_download", "/pdf/NZ_VABYSMO-faricimab-Informational-Patient-Brochure_M-NZ-00000916_v5_NOV2025.pdf", e)}>

                    View Information Brochure	</a>
                </div>
              </div>

              <div className=" col-md-3 col-xs-12 ">
                <div className='image-on-card'>
                  <TranslatedBlock language="english">
                    <a href="/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf" title="educational resource in print or audio" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf", e)} target="_blank">
                      <img srcSet={CardThreeImage} alt="educational resource in print or audio" className={'img-responsive'} />
                    </a>
                  </TranslatedBlock>
                </div>
                <div className='textonCard text-center'>
                  <h4><a href="/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf", e)} target="_blank" className='' title="VABYSMO Patient & Caregiver Guide ">VABYSMO Patient & Caregiver Guide </a></h4>
                  <p>An educational resource in print or audio format to help you learn about starting treatment with VABYSMO</p>
                  <a href="/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-patient-booklet_M-NZ-00000690_v5_NOV2025.pdf", e)} target="_blank" className='yellow-buttons' title=" View Patient / Caregiver Guide (ENG)">

                    View Patient / Caregiver Guide (ENG)	</a>
                  <p>
                    <a href="/pdf/NZ_VABYSMO-faricimab-patient-booklet-Simplified-Chinese-edition_M-NZ-00000857_v4_NOV2025.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-patient-booklet-Simplified-Chinese-edition_M-NZ-00000857_v4_NOV2025.pdf", e)} target="_blank" className='download-paitent-brochure' title=" View Patient / Caregiver Guide [中文]">
                      <img srcSet={DownloadIcon} alt=" View Patient" className='donwload-image' />
                      View Patient / Caregiver Guide [中文]
                    </a>
                    <a href="/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Te-Reo-Māori-version_M-NZ-00001393_v2_NOV2025.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Te-Reo-Māori-version_M-NZ-00001393_v2_NOV2025.pdf", e)} target="_blank" className='download-paitent-brochure' title=" View Patient / Caregiver Guide [Te Reo Māori]">
                      <img srcSet={DownloadIcon} alt=" View Patient" className='donwload-image' />
                      View Patient / Caregiver Guide <br /> [Te Reo Māori]
                    </a>
                    <a href="/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Samoan-version_M-NZ-00001394_v2_NOV2025.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Samoan-version_M-NZ-00001394_v2_NOV2025.pdf", e)} target="_blank" className='download-paitent-brochure' title=" View Patient / Caregiver Guide [Samoan]">
                      <img srcSet={DownloadIcon} alt=" View Patient" className='donwload-image' />
                      View Patient / Caregiver Guide <br /> [Samoan]
                    </a>
                    <a href="/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Hindi-version_M-NZ-00001692_v1_JUN2026.pdf" onClick={(e) => this.trackDownloads("caregiver_guide_download", "/pdf/NZ_VABYSMO-faricimab-Patient-Booklet-Hindi-version_M-NZ-00001692_v1_JUN2026.pdf", e)} target="_blank" className='download-paitent-brochure' title=" View Patient / Caregiver Guide [Hindi]">
                      <img srcSet={DownloadIcon} alt=" View Patient" className='donwload-image' />
                      View Patient / Caregiver Guide <br /> [Hindi]
                    </a>
                  </p>

                  <button className="listen download-paitent-brochure text-center" onClick={() => {
                    this.setState({ isAudioVisible: true });
                    this.trackDownloads("caregiver_guide_audio_played");
                  }
                  }>  <span>&#128362;</span> Listen to  Audio Version
                  </button>
                  <TranslatedBlock language="english">
                    {this.state.isAudioVisible ? (
                      <div className="audio-el">
                        {/* eslint-disable jsx-a11y/media-has-caption */}
                        <audio controls autoPlay src=" /audio/Vabysmo_Patient Booklet_audio guide_NZ.mp3">
                          Your browser does not support the
                          <code>audio</code> element.
                        </audio>
                        {/* eslint-enable jsx-a11y/media-has-caption */}
                      </div>
                    ) : (
                      ''
                    )}
                  </TranslatedBlock>
                </div>
              </div>

              <div className=" col-md-3 col-xs-12 ">
                <div className='image-on-card'>
                  <TranslatedBlock language="english">
                    <a href="/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf" target="_blank" title="Amsler Grid" onClick={(e) => this.trackDownloads("amsler_grid_download", "/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf", e)}>
                      <img srcSet={CardFourImage} alt="Amsler Grid" className={'img-responsive'} />
                    </a>
                  </TranslatedBlock>
                </div>
                <div className='textonCard text-center'>
                  <h4><a href="/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf" title="Amsler Grid" target="_blank" className='' onClick={(e) => this.trackDownloads("amsler_grid_download", "/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf", e)}>Check your vision with the Amsler Grid</a></h4>
                  <p>An Amsler grid is a simple test that can help you monitor your vision at home. It is not designed as a diagnosis tool

                  </p>
                  <a href="/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf" title="Amsler Grid" target="_blank" className='yellow-buttons' onClick={(e) => this.trackDownloads("amsler_grid_download", "/pdf/NZ_Amsler-grid-downloadable-resource_M-NZ-00001378_v1_AUG2025.pdf", e)}>
                    View Amsler Grid </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    );
  }
}

export default threeColumnCards;